import { isServerSide } from "@jti/fe-common";
export class BrowserStorage {
    constructor(_storage = !isServerSide() ? window.localStorage : undefined) {
        this._storage = _storage;
    }
    get(key, defaultValue) {
        var _a;
        const value = (_a = this._storage) === null || _a === void 0 ? void 0 : _a.getItem(key);
        if (!value) {
            return defaultValue;
        }
        return JSON.parse(value);
    }
    set(key, value) {
        var _a;
        (_a = this._storage) === null || _a === void 0 ? void 0 : _a.setItem(key, JSON.stringify(value));
    }
    delete(key) {
        var _a;
        (_a = this._storage) === null || _a === void 0 ? void 0 : _a.removeItem(key);
    }
}
export default BrowserStorage;
export const getSessionStorage = () => new BrowserStorage(window.sessionStorage);
export const getLocalStorage = () => new BrowserStorage(window.localStorage);
//# sourceMappingURL=BrowserStorage.js.map